import { getSubtitleWithProgress } from '@air/feature-file-status/utils';
import { UploadStatus } from '@air/redux-uploader';

export type GetWorkspaceUploadsItemStatusCopyArgs = {
  currentBytesUploaded: number;
  errorMessage?: string;
  sizeInBytes: number;
  status: UploadStatus;
};

export const getWorkspaceUploadsItemStatusCopy = ({
  currentBytesUploaded,
  errorMessage,
  sizeInBytes,
  status,
}: GetWorkspaceUploadsItemStatusCopyArgs): string => {
  if (status === UploadStatus.failed) {
    return `Error: ${errorMessage ?? 'Failed'}`;
  }

  if (status === UploadStatus.completed) {
    return getSubtitleWithProgress({
      sizeInBytes,
      title: 'Completed',
      uploadedBytes: sizeInBytes,
    });
  }

  if (status === UploadStatus.paused) {
    return getSubtitleWithProgress({
      sizeInBytes,
      title: 'Paused',
      uploadedBytes: currentBytesUploaded,
    });
  }

  if (status === UploadStatus.queued || status === UploadStatus.preparing) {
    return 'Queued';
  }

  return getSubtitleWithProgress({
    sizeInBytes,
    title: 'Uploading',
    uploadedBytes: currentBytesUploaded,
  });
};
